import { EpimsBaseEntityDto } from './epim-base.dto';
export class ObligationPaymentDto extends EpimsBaseEntityDto {

   DatePaid: Date;
   LandName: string;
   LandCode: string;
   Remarks: string;
   TotalAmount: string;
   Unit: string;
   Uom: string;
   Terrain: string;
   FromDate: Date;
   ToDate: Date;
   Status: string;
   SubscriptionUserId: string;
   LandTitleId: string;

}
